/**
 *
 * Asynchronously loads the component for OrderDetail
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
